import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { MenuRolePayload, MenuRolePayloadUpdate, MenuRoleResponse } from "@/types/interface/menu-role";

async function createMenuRole(payload: MenuRolePayload) {
  return await http.post<APIResponse<MenuRoleResponse>>("menu-role/create", payload);
}

async function updateMenuRole(payload: MenuRolePayloadUpdate) {
  return await http.patch<APIResponse<MenuRoleResponse>>(`menu-role/update`, payload);
}

async function getMenuRole(idMenuRole = 1) {
  return await http.get<APIResponse<MenuRoleResponse>>(`menu-role?role_id=${idMenuRole}`);
}

async function findMenuRole(idMenuRole = "") {
  return await http.get<APIResponse<MenuRoleResponse>>(`menu-role/detail?id=${idMenuRole}`);
}

async function deleteMenuRole(idMenuRole = "") {
  return await http.delete<APIResponse<MenuRoleResponse>>(`menu-role/delete?id=${idMenuRole}`);
}

export default {
  createMenuRole,
  updateMenuRole,
  getMenuRole,
  findMenuRole,
  deleteMenuRole
};